(ns ballot-scout-v2-frontend.config
  (:require
   [clojure.string :as str])
  (:require-macros
   [ballot-scout-v2-frontend.config-helpers :refer [optional-env-var]]))

(def debug?
  ^boolean goog.DEBUG)

(def base-faq-url "https://www.ballotscout.org")
(def default-faq-url (str base-faq-url "/faq-en"))
(def feature-flags
  {:voter-lookup-filter-tags   (optional-env-var :ff-voter-lookup-filter-tags)
   :voter-lookup-filter-drawer (optional-env-var :ff-voter-lookup-filter-drawer)})
(defn feature? [flag-key]
  (some->> flag-key
           feature-flags
           str/lower-case
           (contains? #{"true" "t" "1"})))


